export default __webpack_public_path__ + "static/media/wisc-shop-chat-bot.9fc0e058.jpg";